const LEAVE_EVENTS = {
  LEAVE_OPEN: 'LEAVE:OPEN',
  LEAVE_CLOSE: 'LEAVE:CLOSE',
  LEAVE_TIMESHEET_SELECTION_CHANGED: 'LEAVE:TIMESHEET_SELECTION_CHANGED',
  UPDATE_LEAVE_POLICIES_DIALOG_SHOW: 'LEAVE:UPDATE_LEAVE_POLICIES_DIALOG:SHOW',
  LEAVE_MIGRATION_STARTED: 'LEAVE:MIGRATION_STARTED',
};

export default LEAVE_EVENTS;
